import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [{//nav
        path: '/',
        name: 'nav',
        component: require('@/components/nav')
    }, {
        path: '/yymore',//数据分析
        name: 'yymore',
        component: require('@/components/yymore')
    }, {
        path: '/news',//新闻
        name: 'news',
        component: require('@/components/news')
    },{
        path: '/content',//新闻
        name: 'content',
        component: require('@/components/content')
    },{
        path: '/help',//帮助中心
        name: 'help',
        component: require('@/components/help')
    }
	
	/*, {
        path: '/preview/pc/:id',//数据日志
        component: require('@/components/preview_product')
    }, {
        path: '*',
        redirect: '/'
    }*/]
})



// WEBPACK FOOTER //
// ./src/router/index.js